import client_core from "@/services/clients/client_core";

const TimingServiceService = {

    getTimingServices() {
        return client_core.get('/dashboard/v1/timing-services/')
    },
}

export default TimingServiceService